<aslib-title ></aslib-title>

<form novalidate [formGroup]='formMunicipiosAptos'>
  <div class="form-group row" *ngIf="exibirCxMunicipios" >
    <label for="" class="col-12">Selecione os Municípios:</label>
    <div class="controls col-5">
      <select id="Municipios" formControlName="municipios" [(ngModel)]="municipiosSelect" style="width: 100%;min-height: 200px;" multiple size="5">
        <option *ngFor="let item of municipiosVig" [value]="item">{{ item.Descricao }}</option>
      </select>
    </div>
    <div class="controls col-5">
      <button type="button" class="btn btn-primary" (click)="adicionar(municipiosSelect)" >
        <aslib-icon type="1" icon="fa fa-plus"></aslib-icon>Adicionar</button>
    </div>
  </div>

<div class="form-group row mb-5" *ngIf="listaMunicipios.length>0" >
  
  <aslib-grid #grid id="as-libgrid" class="col-md-12" [(dataset)]="listaMunicipios" [pagination]="false" [regPerPageVisible]="false" [limit]="listaMunicipios.length" >
    
    <aslib-grid-column [property]="'Descricao'" [header]="'Município'" [width]="100" [sortable]="true"></aslib-grid-column>
    
    <aslib-grid-column [property]="'dtIni'"  [width]="60" [header]="'Início Vigência'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" let-rowIndex="rowIndex">
        <input type="text" appMonthYear placeholder="MM/AAAA" [(ngModel)]="item.dtIni" [ngModelOptions]="{ standalone: true }" [attr.id]="'dtIni-' + rowIndex"/>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'dtFim'"  [width]="50" [header]="'Fim Vigência'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" let-rowIndex="rowIndex">
        <input type="text" appMonthYear placeholder="MM/AAAA" [(ngModel)]="item.dtFim" [ngModelOptions]="{ standalone: true }" [attr.id]="'dtFim-' + rowIndex"/>
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'obs'"  [width]="100" [header]="'Observações'"  [sortable]="true">
      <ng-template #AslibGridCell let-item="item" let-rowIndex="rowIndex">
        <input type="text" [(ngModel)]="item.obs" [ngModelOptions]="{ standalone: true }" [attr.id]="'obs-' + rowIndex" style="width: 100%;" maxlength="200"  />
      </ng-template>
    </aslib-grid-column>
    <aslib-grid-column [property]="'active'" [header]="'Ações'" [width]="40" [sortable]="false" [resizable]="false"
      class="text-center">
      <ng-template #AslibGridHeader let-item="item"><span>Ações</span></ng-template>
      <ng-template #AslibGridCell let-item="item">
        <button type="button" class="btn btn-sm btn-primary" title="Excluir"
          ascas-data="Excluir registro" (click)="excluir(modalMensagem,item)">
          <aslib-icon type="1" icon="fa fa-trash"></aslib-icon>
        </button>
      </ng-template>
    </aslib-grid-column>
  </aslib-grid>
</div>
  <div class="form-group row"  >
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" [disabled]="!(listaMunicipios.length>0)" (click)="salvarDados(grid)"  >
        <aslib-icon type="1" icon="fa fa-save"></aslib-icon>Salvar
      </button>
      <button type="button" class="btn btn-primary" [disabled]="!(listaMunicipios.length>0)" (click)="limpar()"  >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar
      </button>
      <button type="button" class="btn btn-primary" (click)="irPraConsulta()"  >
        <aslib-icon type="1" icon="fa fa-ban"></aslib-icon>Cancelar
      </button>
    </div>

  </div>
</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/cadastra-municipios-aptos.component.html